// Migrated from app/assets/javascripts/locale.js
// Translation helper using global __locale object
// __locale is set by a <script> tag loaded from /javascripts/locales/{locale}.js

function translate( key, options ) {
  options = options || {};
  if (typeof __locale === 'undefined') return options.default || key;
  return __locale[key] || options.default || key;
}

window.translate = translate;
window.t = window.t || translate;
